import "./PickAddon.css"
import React, {useEffect, useState} from "react";
import Loader from "../Loader/Loader";
import {useLoading} from "../../context/LoadingContext";
import {useAuth} from "../../context/AuthContext";
import {useAccount} from "../../context/AccountContext";
import {useTranslation} from "react-i18next";
import {useProductFlowContext} from "../../context/ProductFlowContext";
import {useCms} from "../../context/CmsContext";
import CmsHelper, {PickProgramPageHelper} from "../Utilities/CmsHelpers";
import ProductsContainer from "./ProductsContainer/ProductsContainer";
import ProductsService from "../../services/ProductsService";
import {Button} from "@mui/material";
import AccountsService from "../../services/AccountsService";
import EvergentErrors from "../../services/Evergent/EvergentErrors.ts";
import {useNavigate} from "react-router-dom";
import usePaymentProvider from "../../services/PaymentProvider.ts";
import UserService from "../../services/UserService";

function PickAddon() {
  const paymentProvider = usePaymentProvider();
  const {t} = useTranslation();

  const {isLoading, addLoading, removeLoading} = useLoading();
  const {loggedIn, authData} = useAuth()
  const account = useAccount();

  const {onNext: newFlow, selectedProduct, resetFlow} = useProductFlowContext()

  const {pickProgramData} = useCms();
  const pickAddons = PickProgramPageHelper.getPickAddons(PickProgramPageHelper.getPrograms(pickProgramData, CmsHelper.DEFAULT));

  useEffect(() => {
    if (!(isLoading("INIT"))) {
      addLoading("INIT")
    }
    if (loggedIn) {
      removeLoading("INIT")
    }
  }, [loggedIn]); //eslint-disable-line react-hooks/exhaustive-deps

  const [loading, setLoading] = useState(false)

  const navigate = useNavigate();

  const [onNext, setOnNext] = useState(()=>{})
  const onNextAction = async (product) =>{
    let request = {
      pricePoint: product.addonPricePoint,
    };

    return AccountsService.subscribeAddon({...request})
        .then((response) => {
          window.addEventListener("message", function handleMessage(event){
            console.debug(event)
            const iframeUrl = new URL(response.data.uri);
            if (!iframeUrl || (event.origin !== iframeUrl?.origin && event.origin !== window.location.origin)) {
              return;
            }

            let data;
            try {
              data = JSON.parse(event.data);
            }catch (e){
              data = event.data;
            }

            if(data?.status !== undefined){
              window.removeEventListener("message", handleMessage);
              if((parseInt(data?.status) === 1)){
                console.log("Successful flow, status: ", parseInt(data?.status))

                if(data?.mlink){
                  sessionStorage.setItem("addon-mlink", JSON.stringify({
                    mlink: data?.mlink,
                    addon: {
                      skuORQuickCode: request?.pricePoint
                    }}))
                }
                AccountsService.getAccounts()
                .then(r => {
                  if(r?.data?.subscription?.addons.length > 0){
                    let element = r?.data?.subscription?.addons[0];
                    const newProductAddon = {
                      skuName : element?.product?.name,
                      skuId : element?.product?.product_price_point_handle,
                      prodAttribute: element?.productAttribute,
                      price: element?.product?.price_with_tax,
                      priceWithTax: element?.product?.price_with_tax
                    };
                    account.setupAnalyticsAddonProductConvertion(newProductAddon);
                  }
                })
                .catch((err) => {
                  console.error(err)
                });
                UserService.isSubscriptionAction()
                navigate("/CongratsPage")
              } else if(parseInt(data.status) === 0){
                if(data.errorCode === EvergentErrors.REQUEST_TERMINATED.value){
                  window.location.replace("/pickAddon"); //replace so user cant go back to /cartPage without any state
                }
              } else if(parseInt(data.status) === 400) {
                window.removeEventListener("message", handleMessage);
              }
            }
          })
          navigate(paymentProvider.paymentForm, {state: {uri: response.data.uri}})
        })
        .catch((err) => {
          //TODO handle error
        });
  }

  const handleSubmit = (e) =>{
    e.preventDefault();
    const checkedItems = addons;
    setLoading(true)
    onNext(checkedItems[0]?.skuORQuickCode ? {addonPricePoint: checkedItems[0]?.skuORQuickCode} : null)
        .finally(() => setLoading(false))
  }

  const getPrice = (price) => {
      try {
          let res = price/100;
          if(!Number.isNaN(res))
              return res;
      } catch (e) {
      }
      return undefined;
  }

  const [addons, setAddons] = useState(null)
  
  useEffect(()=>{
    const currentProductAddons = async () => {
      let {productId, pricePoint} = authData;

      return ProductsService.getProductReferenceStandalone({
        productId: productId,
        pricePoint: pricePoint
      }).then(res => {
        return res.data?.addons;
      }).catch(e => {
        console.debug("Error occured: ", e.message)
        return [];
      });
    }

    if(selectedProduct?.addons){
      setAddons(selectedProduct?.addons)
      setOnNext(()=> async (...props) => newFlow(...props))
    }else{
      currentProductAddons()
          .then(r =>{
            setAddons(r)
            setOnNext(()=> async (...props) => onNextAction(...props))
          })
    }
    // eslint-disable-next-line
  }, [selectedProduct])


  useEffect(()=>{
    return () =>{
      resetFlow();
    }
  }, [])

  return (<>
    {isLoading() ? (<Loader />) : (
      <>
        <div className={"pickaddon-wrapper"}
             style={{
               backgroundImage: !!pickAddons?.backgroundImage?.url ? `url("${pickAddons?.backgroundImage.url}")` : ``
        }}>
          <div className={"pickaddon-upper"}>
            <div className={"pickaddon-header-wrapper"}>
              <div className={"pickaddon-header"}>
                <span className={"pickaddon-header-title"}>
                  {pickAddons?.title}
                </span>
                <span className={"pickaddon-header-subtitle"}>
                  {pickAddons?.subtitle}
                </span>
              </div>
            </div>
          </div>
          {(loading || (!(!!onNext) && !addons)) ? (<Loader />) : (
              <>
                <form onSubmit={handleSubmit}>
                  <ProductsContainer product={addons} pickAddons={pickAddons?.addons} />
                  <div className={"pickaddon-cta-wrapper"}>
                    {!!addons?.length ?
                        <>
                          {selectedProduct?.addons?.length ?
                            <Button
                                variant="outlined"
                                color="secondary"
                                className={"cta-button"}
                                onClick={(e)=> {
                                  e.preventDefault();
                                  onNext(null)
                                }}>
                              {t("pickAddonContinueWithoutAddons")}
                            </Button>: <></>
                          }
                          <Button
                              variant="contained"
                              color="primary"
                              className={"cta-button"}
                              type={"submit"}>
                            {t("pickAddonContinueWithAddons")}
                          </Button>
                        </>
                        : <></>
                    }
                  </div>
                </form>
              </>
          )}
        </div>
      </>)
    }
  </>);
}

export default PickAddon;
